import { BsPencil } from 'react-icons/bs'
import TableButton from './TableButton'
import { Dropdown, IDropdownItem } from 'components/UI/Dropdown/Dropdown'
import React from 'react'
import { useTableLinkVariant } from 'components/Tables/CommonTableCells/TableLinkStyleContext'

export default function TableButtonAction({
  selectedRowsCount,
  items,
  isDoorsTable,
  entityType,
  disabled,
}: {
  selectedRowsCount: number
  items?: IDropdownItem[]
  isDoorsTable?: boolean
  entityType?: string
  disabled?: boolean
} & Partial<React.ComponentProps<typeof TableButton>>) {
  const variant = useTableLinkVariant()
  if (selectedRowsCount === 0) {
    return null
  }

  const defaultEntityType = isDoorsTable ? 'doors' : 'rows'
  const finalEntityType = entityType || defaultEntityType
  const menuLabelText = `Apply to selected ${finalEntityType} (${selectedRowsCount})`

  // h-7 (28px) so the bulk Actions button sits with clear margin inside the
  // 40px DS2026 header row without clipping.
  const plainClassName =
    '!min-h-7 !h-7 !px-3 !text-sm !bg-brand-bright hover:!bg-brand-active'

  return (
    <div data-bulk-actions={variant === 'plain' ? 'true' : undefined}>
      <Dropdown
        className={variant === 'plain' ? plainClassName : 'mt-2'}
        buttonIcon={variant === 'plain' ? undefined : <BsPencil size={20} />}
        buttonLabel="Actions"
        buttonVariant="primary"
        items={items ?? []}
        menuLabel={menuLabelText}
        disabled={disabled || selectedRowsCount === 0}
      />
    </div>
  )
}
